const FIAT = [
  { code: "TRY", name: "Türk Lirası", symbol: "₺", color: "#e11d48" },
  { code: "USDT", name: "Dolar", symbol: "$", color: "#26a17b" },
];

const TRY_PER = {
  TRY: 1,
  USDT: 50,
};

const ALLOWED = new Set(FIAT.map((item) => item.code));

function normalizeCurrency(code) {
  const next = String(code || "TRY").toUpperCase();
  if (next === "USD") return "USDT";
  if (next === "EUR") return "TRY";
  return ALLOWED.has(next) ? next : "TRY";
}

const state = {
  currency: normalizeCurrency(typeof localStorage !== "undefined" ? localStorage.getItem("bet_fx") : "TRY"),
  usd: TRY_PER.USDT,
};

export function fiatList() {
  return FIAT;
}

export function fiatOf(code = state.currency) {
  const next = normalizeCurrency(code);
  return FIAT.find((item) => item.code === next) || FIAT[0];
}

export function setMoneyContext({ currency, usd } = {}) {
  if (currency) {
    const next = normalizeCurrency(currency);
    state.currency = next;
    if (typeof localStorage !== "undefined") localStorage.setItem("bet_fx", next);
  }
  if (usd) {
    const rate = Number(usd);
    if (rate > 0) {
      state.usd = rate;
      TRY_PER.USDT = rate;
    }
  }
}

export function currentCurrency() {
  return normalizeCurrency(state.currency);
}

export function fromTRY(value, currency = state.currency) {
  const amount = Number(value) || 0;
  const rate = TRY_PER[normalizeCurrency(currency)] || 1;
  return amount / rate;
}

export function toTRY(value, currency = state.currency) {
  const amount = Number(value) || 0;
  const rate = TRY_PER[normalizeCurrency(currency)] || 1;
  return amount * rate;
}

function localeOf() {
  const lang = typeof localStorage !== "undefined" ? localStorage.getItem("bet_lang") : "tr";
  return lang === "en" ? "en-US" : "tr-TR";
}

export function formatMoney(value, currency = state.currency) {
  const code = normalizeCurrency(currency);
  const converted = fromTRY(value, code);
  const formatted = converted.toLocaleString(localeOf(), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (code === "TRY") return `${formatted} ₺`;
  return `$${formatted}`;
}

export function formatTRY(value) {
  return formatMoney(value, currentCurrency());
}

/** Sohbet kasa/yağmur — her zaman TRY (kur seçiminden bağımsız). */
export function formatChatTRY(value) {
  const amount = Number(value) || 0;
  const formatted = amount.toLocaleString(localeOf(), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formatted} ₺`;
}

/** Canlı bahis tablosu — kuruşsuz tam tutar */
export function formatTRYWhole(value) {
  const code = normalizeCurrency(state.currency);
  const tryAmount = Math.round(Number(value) || 0);
  const converted = Math.round(fromTRY(tryAmount, code));
  const formatted = converted.toLocaleString(localeOf(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  if (code === "TRY") return `${formatted} ₺`;
  return `$${formatted}`;
}

/** Orijinal oyun tablosu — seçili para biriminde kuruşlu */
export function formatPlayTable(value) {
  return formatMoney(value, state.currency);
}

export function playChips(currency = state.currency) {
  const code = normalizeCurrency(currency);
  if (code === "TRY") return [10, 20, 50, 100, 250, 1000, 10000];
  return [1, 2, 5, 10, 20, 50, 100];
}

export function gameLangOf(currency = state.currency) {
  const code = normalizeCurrency(currency);
  if (code === "USDT") return "en";
  return "tr";
}

export { TRY_PER };
